import PushListRoute from './PushListRoute';

export default PushListRoute;
